var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoChats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.749,
    height: 50.294,
    viewBox: "0 0 55.749 50.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#80e8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c278"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(-33.508 -49.8)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M71.6,161.736a20.488,20.488,0,0,1-3.551,3.03,23.285,23.285,0,0,1-13.073,3.909A23.751,23.751,0,0,1,45.42,166.7c-4.078,4.155-10.592,3.776-10.592,3.776l5.121-7.208a17.811,17.811,0,0,1-6.441-13.5,17.572,17.572,0,0,1,5.178-12.313,20.9,20.9,0,0,1,3.877-3.111,18.874,18.874,0,0,0-1.343,6.992c0,11.68,10.754,21.147,24.018,21.147A27.015,27.015,0,0,0,71.6,161.736Z",
    transform: "translate(0 -70.394)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M114.795,132.479a17.5,17.5,0,0,1-4.845,11.963,27.015,27.015,0,0,1-6.364.752c-13.264,0-24.018-9.467-24.018-21.147a18.875,18.875,0,0,1,1.343-6.992,23.42,23.42,0,0,1,12.415-3.478C105.182,113.577,114.795,122.038,114.795,132.479Z",
    transform: "translate(-38.348 -53.099)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M120.4,86.047l5.73,8.066s-7.29.423-11.851-4.225a25.954,25.954,0,0,1-4.33,1.454,27.015,27.015,0,0,1-6.364.752c-13.264,0-24.018-9.467-24.018-21.147a18.875,18.875,0,0,1,1.343-6.992C84.189,55.711,93.1,49.8,103.585,49.8c13.265,0,24.02,9.465,24.02,21.147A19.926,19.926,0,0,1,120.4,86.047Z",
    transform: "translate(-38.348 0)",
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 3.437,
    cy: 3.437,
    r: 3.437,
    transform: "translate(52.833 68.794)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 3.437,
    cy: 3.437,
    r: 3.437,
    transform: "translate(62.142 68.794)",
    fill: "#2a94f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 3.437,
    cy: 3.437,
    r: 3.437,
    transform: "translate(71.451 68.794)",
    fill: "#2a94f4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChats);
export default __webpack_public_path__ + "static/media/no-chats.5f7311688069c8025d08bcebe0549955.svg";
export { ForwardRef as ReactComponent };